
import Vue from 'vue'

import forgotpwd from './forgotpwd.vue'

const Instance = Vue.extend(forgotpwd);
const element = new Instance().$mount();

const promp = {
    open() {       
        document.body.appendChild(element.$el);
    },
    close() {
        document.body.removeChild(element.$el);
    }
}

export default promp;